import { render, staticRenderFns } from "./PriceBox.vue?vue&type=template&id=41cf5a4e&"
import script from "./PriceBox.vue?vue&type=script&lang=js&"
export * from "./PriceBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports